import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/two-factor/')({
  beforeLoad: () => {
    throw redirect({ to: '/profile' })
  },
})
